<section class="page-user-profile">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="user-profile-images">
          <!-- user timeline image -->
          <img src="assets/img/banner/Profile Banner.png" class="img-fluid rounded-top user-timeline-image" alt="User Timeline Image">
          <!-- user profile image -->
          <img src="assets/MeanderLIVE-icon.png" class="user-profile-image rounded" alt="User Profile Image" height="140" width="140">
        </div>
        <div class="user-profile-text">
          <h4 class="profile-text-color mb-0">{{this.user?.name}}</h4>
        </div>
        <!-- user profile body start -->
        <div class="card-content">
          <div class="card-body">
            <div class="user-profile-buttons d-flex justify-content-center justify-content-sm-start">
              <!-- <button class="btn btn-primary mr-3">Follow</button>
              <button class="btn bg-light-primary">Edit</button> -->
            </div>
          </div>
          <!-- user profile body ends -->
        </div>
      </div>
    </div>
  </div>
  <!-- Profile posts and info starts -->
  <div class="row profile-info-posts">
    <!-- 1st column starts -->
    <div class="col-lg-3 col-12">
      <div class="row">
        <!-- About starts -->
        <div class="col-12">
          <div class="card">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h4 class="card-title m-0">About</h4>
              <span class="cursor-pointer"><i class="ft-more-vertical-"></i></span>
            </div>
            <div class="card-content">
              <div class="card-body">
                <p class="m-0">Ice cream sweet chupa chups oat cake croissant halvah cake. Halvah macaroon jelly-o gingerbread cheesecake carrot cake. Muffin donut ice cream brownie cheesecake halvah... <a href="javascript:;">MORE</a></p>
              </div>
            </div>
          </div>
        </div>
        <!-- About ends -->

        <!-- Info starts -->
        <div class="col-12">
          <div class="card">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h4 class="card-title m-0">Info</h4>
              <span class="cursor-pointer"><i class="ft-more-vertical-"></i></span>
            </div>
            <div class="card-content">
              <div class="card-body">
                <ul class="list-unstyled mb-0">
                  <li class="d-flex align-items-center">
                    <i class="ft-briefcase mr-2 cursor-pointer"></i><span>UX Designer at <a href="https://pixinvent.com/" target="_blank">PIXINVENT</a></span>
                  </li>
                  <li class="d-flex align-items-center">
                    <i class="ft-briefcase mr-2 cursor-pointer"></i><span>Former UI Designer at <a href="javascript:;">CBI</a></span>
                  </li>
                  <li class="d-flex align-items-center">
                    <i class="ft-file-text mr-2 cursor-pointer"></i><span>Studied <a href="javascript:;">IT science</a> at <a href="javascript:;">Torronto</a></span>
                  </li>
                  <li class="d-flex align-items-center">
                    <i class="ft-file-text mr-2 cursor-pointer"></i><span>Studied at <a href="javascript:;">College of New Jersey</a></span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!-- Info ends -->

        <!-- Followers starts -->
        <div class="col-12">
          <div class="card">
            <div class="card-content">
              <div class="card-body d-flex justify-content-between">
                <div class="followers-posts text-center">
                  <h4 class="m-0">400</h4>
                  <small class="text-muted">Posts</small>
                </div>
                <div class="followers text-center">
                  <h4 class="m-0">194k</h4>
                  <small class="text-muted">Followers</small>
                </div>
                <div class="followers-following text-center">
                  <h4 class="m-0">248</h4>
                  <small class="text-muted">Following</small>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Followers ends -->

        <!-- Skills starts -->
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Skills</h4>
            </div>
            <div class="card-content">
              <div class="card-body">
                <span class="badge badge-pill bg-light-primary mr-1 mb-1">Product Design</span>
                <span class="badge badge-pill bg-light-secondary mr-1 mb-1">Technology</span>
                <span class="badge badge-pill bg-light-warning mr-1 mb-1">Wordpress</span>
                <span class="badge badge-pill bg-light-info mr-1 mb-1">Sketch</span>
                <span class="badge badge-pill bg-light-danger mr-1 mb-1">Mobile App</span>
                <span class="badge badge-pill bg-light-primary mr-1 mb-1">UI</span>
                <span class="badge badge-pill bg-light-secondary mr-1 mb-1">UX</span>
              </div>
            </div>
          </div>
        </div>
        <!-- Skills ends -->

        <!-- Friends starts -->
        <div class="col-12">
          <div class="card">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h4 class="card-title m-0">Friends</h4>
              <a href="javascript:;">See All</a>
            </div>
            <div class="card-content">
              <div class="card-body">
                <img src="assets/img/portrait/small/avatar-s-15.png" alt="" class="img-fluid avatar mb-1 mr-1" width="35" height="35">
                <img src="assets/img/portrait/small/avatar-s-10.png" alt="" class="img-fluid avatar mb-1 mr-1" width="35" height="35">
                <img src="assets/img/portrait/small/avatar-s-11.png" alt="" class="img-fluid avatar mb-1 mr-1" width="35" height="35">
                <img src="assets/img/portrait/small/avatar-s-9.png" alt="" class="img-fluid avatar mb-1 mr-1" width="35" height="35">
                <img src="assets/img/portrait/small/avatar-s-24.png" alt="" class="img-fluid avatar mb-1 mr-1" width="35" height="35">
                <img src="assets/img/portrait/small/avatar-s-19.png" alt="" class="img-fluid avatar mb-1 mr-1" width="35" height="35">
                <img src="assets/img/portrait/small/avatar-s-26.png" alt="" class="img-fluid avatar mb-1" width="35" height="35">
              </div>
            </div>
          </div>
        </div>
        <!-- Friends ends -->
      </div>
    </div>
    <!-- 1st column ends -->
    <!-- 2nd column starts -->
    <div class="col-lg-6 col-12">
      <div class="row">
        <!-- Post starts -->
        <div class="col-12">
          <div class="card profile-post overflow-hidden">
            <img src="assets/img/banner/banner-15.jpg" class="img-fluid profile-post-img" alt="Post Image">
            <div class="card-content">
              <div class="card-body">
                <h5 class="primary">User Friendly</h5>
                <h4>Time to break up with your web host</h4>
                <p class="m-0">Gummi bears gummi bears cake jelly-o. Bear claw marshmallow lemon drops biscuit caramels. Tart jelly-o muffin. Toffee pie cheesecake apple pie sesame snaps. Candy canes candy canes dragée chocolate pudding. Soufflé chocolate bar pastry jujubes.</p>
                <div class="media d-flex align-items-center pb-0">
                  <img src="assets/img/portrait/small/avatar-s-11.png" class="mr-2 avatar" alt="Avatar" height="40" width="40">
                  <div class="media-body">
                    <h5 class="m-0">David Carter</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Post ends -->

          <!-- Profile Slider starts -->
          <div class="col-12">
            <div class="card">
                <div class="card-content">
                    <div class="card-body">
                        <h5 class="card-title mb-2">Stories</h5>
                        <div class="user-profile-stories swiper-container pt-1" [swiper]="swipeConfig">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide">
                                    <img src="assets/img/profile/profile-portrait-1.jpg" class="rounded user-profile-stories-image" alt="story-image-1">
                                    <div class="card-img-overlay bg-overlay">
                                        <div class="user-swiper-text">devine_lena</div>
                                    </div>
                                </div>
                                <div class="swiper-slide">
                                    <img src="assets/img/profile/profile-portrait-2.jpg" class="rounded user-profile-stories-image" alt="story-image-2">
                                    <div class="card-img-overlay bg-overlay">
                                        <div class="user-swiper-text">ureka_23</div>
                                    </div>
                                </div>
                                <div class="swiper-slide">
                                    <img src="assets/img/profile/profile-portrait-3.jpg" class="rounded user-profile-stories-image" alt="story-image-3">
                                    <div class="card-img-overlay bg-overlay">
                                        <div class="user-swiper-text">venice_like852</div>
                                    </div>
                                </div>
                                <div class="swiper-slide">
                                    <img src="assets/img/profile/profile-portrait-6.jpg" class="rounded user-profile-stories-image" alt="story-image-4">
                                    <div class="card-img-overlay bg-overlay">
                                        <div class="user-swiper-text">june5211</div>
                                    </div>
                                </div>
                                <div class="swiper-slide">
                                    <img src="assets/img/profile/profile-portrait-7.jpg" class="rounded user-profile-stories-image" alt="story-image-5">
                                    <div class="card-img-overlay bg-overlay">
                                        <div class="user-swiper-text">defloya_456</div>
                                    </div>
                                </div>
                                <div class="swiper-slide">
                                    <img src="assets/img/profile/profile-portrait-8.jpg" class="rounded user-profile-stories-image" alt="story-image-6">
                                    <div class="card-img-overlay bg-overlay">
                                        <div class="user-swiper-text">allen5196</div>
                                    </div>
                                </div>
                                <div class="swiper-slide">
                                    <img src="assets/img/profile/profile-portrait-9.jpg" class="rounded user-profile-stories-image" alt="story-image-7">
                                    <div class="card-img-overlay bg-overlay">
                                        <div class="user-swiper-text">cecilia_698</div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="swiper-scrollbar" [hidden]="config.scrollbar === false"></div>
                            <div class="swiper-pagination" [hidden]="config.pagination === false"></div>

                            <div class="swiper-button-prev" [hidden]="config.navigation === false"></div>
                            <div class="swiper-button-next" [hidden]="config.navigation === false"></div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Profile Slider ends -->

        <!-- Job History starts -->
        <div class="col-12">
          <div class="card profile-job-history">
            <div class="card-content">
              <div class="card-body">
                <div class="row">
                  <div class="col-12">
                    <div class="d-sm-flex justify-content-between align-items-center mb-2">
                      <div class="d-flex">
                        <img src="assets/img/portrait/small/avatar-s-10.png" class="avatar mr-3" alt="Avatar" width="50" height="50">
                        <div class="align-self-center">
                          <h6 class="m-0">UX Designer</h6>
                          <small class="text-muted font-small-2">PIXINVENT</small>
                        </div>
                      </div>
                      <div class="text-muted cursor-pointer mt-2 mt-sm-0"><i class="ft-map-pin"></i> New York, USA</div>
                    </div>
                  </div>
                  <div class="col-12">
                    <p>Cookie cake cupcake jelly marzipan cake cookie bonbon. Liquorice lollipop danish liquorice. Caramels dragée candy tootsie roll tart icing chocolate cake. Cake chocolate bar sweet biscuit bear claw.</p>
                    <h6>Media Files (2)</h6>
                    <table class="table table-borderless">
                      <tr>
                        <td class="pl-0 py-0 pr-1"><img src="assets/img/banner/banner-28.jpg" class="img-fluid" alt="Pic1"></td>
                        <td class="pr-0 py-0 pl-1"><img src="assets/img/banner/banner-24.jpg" class="img-fluid" alt="Pic2"></td>
                      </tr>
                    </table>
                    <hr>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="d-sm-flex justify-content-between align-items-center mb-2">
                      <div class="d-flex">
                        <img src="assets/img/icons/sketch-mac-icon.png" class="mr-3" alt="Avatar" width="50" height="50">
                        <div class="align-self-center">
                          <h6 class="m-0">Lead Designer</h6>
                          <small class="text-muted font-small-2">Sketch App</small>
                        </div>
                      </div>
                      <div class="text-muted cursor-pointer mt-2 mt-sm-0"><i class="ft-map-pin"></i> London, UK</div>
                    </div>
                  </div>
                  <div class="col-12">
                    <p>Lemon drops apple pie tart sweet roll gummi bears caramels tart. Powder sweet powder chocolate brownie. Cupcake fruitcake chocolate bar cake marzipan dessert candy gingerbread.</p>
                    <h6>Media Files (2)</h6>
                    <table class="table table-borderless m-0">
                      <tr>
                        <td class="pl-0 py-0 pr-1"><img src="assets/img/banner/banner-34.jpg" class="img-fluid" alt="Pic1"></td>
                        <td class="pr-0 py-0 pl-1"><img src="assets/img/banner/banner-21.jpg" class="img-fluid" alt="Pic2"></td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Job History ends -->
      </div>
    </div>
    <!-- 2nd column ends -->

    <!-- 3rd column starts -->
    <div class="col-lg-3 col-12">
      <div class="row">
        <!-- Trophy starts -->
        <div class="col-12">
          <div class="card bg-primary white">
            <div class="card-content">
              <div class="card-body">
                <div class="media py-1">
                  <i class="ft-award font-large-2"></i>
                  <div class="ml-1 media-body">
                    <h5 class="white">You reached a new Level!</h5>
                    <p class="font-small-2 m-0">Biscuit jelly beans dragée candy canes. Jelly beans sugar plum oat cake jelly toffee marshmallow.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Trophy ends -->
        <!-- Gallery starts -->
        <div class="col-lg-12 col-md-6 col-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Gallery</h4>
            </div>
            <div class="card-content">
              <div class="card-body">
                <div class="row">
                  <div class="col-4 pl-1 pr-0 pb-1">
                    <img src="assets/img/portrait/small/avatar-s-2.png" class="img-fluid" alt="gallery-avtar">
                  </div>
                  <div class="col-4 pl-1 pr-0 pb-1">
                    <img src="assets/img/portrait/small/avatar-s-4.png" class="img-fluid" alt="gallery-avtar">
                  </div>
                  <div class="col-4 pl-1 pr-0 pb-1">
                    <img src="assets/img/portrait/small/avatar-s-6.png" class="img-fluid" alt="gallery-avtar">
                  </div>
                  <div class="col-4 pl-1 pr-0 pb-1">
                    <img src="assets/img/portrait/small/avatar-s-8.png" class="img-fluid" alt="gallery-avtar">
                  </div>
                  <div class="col-4 pl-1 pr-0 pb-1">
                    <img src="assets/img/portrait/small/avatar-s-26.png" class="img-fluid" alt="gallery-avtar">
                  </div>
                  <div class="col-4 pl-1 pr-0 pb-1">
                    <img src="assets/img/portrait/small/avatar-s-12.png" class="img-fluid" alt="gallery-avtar">
                  </div>
                  <div class="col-4 pl-1 pr-0 pb-1">
                    <img src="assets/img/portrait/small/avatar-s-14.png" class="img-fluid" alt="gallery-avtar">
                  </div>
                  <div class="col-4 pl-1 pr-0 pb-1">
                    <img src="assets/img/portrait/small/avatar-s-16.png" class="img-fluid" alt="gallery-avtar">
                  </div>
                  <div class="col-4 pl-1 pr-0 pb-1">
                    <img src="assets/img/portrait/small/avatar-s-18.png" class="img-fluid" alt="gallery-avtar">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Gallery ends -->

        <!-- News starts -->
        <div class="col-lg-12 col-md-6 col-12">
          <div class="card">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h4 class="card-title m-0">News</h4>
              <span class="cursor-pointer"><i class="ft-more-vertical-"></i></span>
            </div>
            <div class="card-content">
              <div class="card-body">
                <ul class="list-unstyled m-0">
                  <li class="d-flex mb-1">
                    <i class="ft-trending-up primary font-medium-2 mr-2 mt-1"></i>
                    <span>There is a meetup in your city on Friday at 16:00. <a href="javascript:;">See Details</a></span>
                  </li>
                  <li class="d-flex mb-1">
                    <i class="ft-trending-up primary font-medium-2 mr-2 mt-1"></i>
                    <span>20% off coupon on selected items at PIXINVENT</span>
                  </li>
                  <li class="d-flex mb-1">
                    <i class="ft-trending-up primary font-medium-2 mr-2 mt-1"></i>
                    <span>Apple has secret team working on satellites to beam data to devices</span>
                  </li>
                  <li class="d-flex mb-1">
                    <i class="ft-trending-up primary font-medium-2 mr-2 mt-1"></i>
                    <span>Towards an era of singularity, where machines will out-think humans</span>
                  </li>
                  <li class="d-flex mb-1">
                    <i class="ft-trending-up primary font-medium-2 mr-2 mt-1"></i>
                    <span>Private equity funds go talent shopping for portfolio companies</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <!-- News ends -->
      </div>
    </div>
    <!-- 3rd column ends -->
  </div>
  <!-- Profile posts and info ends -->
</section>
